import Mock from 'mockjs';

//圖表數據
let List = []

export default {
    getStatisticalData: () => {
        console.log('Mock Data Requested');
        for (let i = 0; i < 7; i++) {
            List.push (
                Mock.mock({
                    蘋果: Mock.Random.float(100, 8000, 0, 0),
                    vivo: Mock.Random.float(100, 8000, 0, 0),
                    oppo: Mock.Random.float(100, 8000, 0, 0),
                    魅族: Mock.Random.float(100, 8000, 0, 0),
                    三星: Mock.Random.float(100, 8000, 0, 0),
                    小米: Mock.Random.float(100, 8000, 0, 0),
                })
            )
        }
        return {
            code: 20000, //狀態碼
            data: {
                //圓餅圖
                videoData: [
                    {
                        name: '小米',
                        value: 2999
                    },
                    {
                        name: '蘋果',
                        value: 5999
                    },
                    {
                        name: 'vivo',
                        value: 1500
                    },
                    {
                        name: 'oppo',
                        value: 1999
                    },
                    {
                        name: '魅族',
                        value: 2200
                    },
                ],
                //柱狀圖
                userData: [
                    {
                        date: '周一',
                        new: 5,
                        active: 200
                    },
                    {
                        date: '周二',
                        new: 10,
                        active: 500
                    },
                    {
                        date: '周三',
                        new: 12,
                        active: 550
                    },
                    {
                        date: '周四',
                        new: 60,
                        active: 800
                    },
                    {
                        date: '周五',
                        new: 60,
                        active: 800
                    },
                    {
                        date: '周六',
                        new: 60,
                        active: 800
                    },
                    {
                        date: '周日',
                        new: 60,
                        active: 800
                    },
                ],
                //折線圖
                orderData: {
                    date: ['20231201','20231202','20231203','20231204','20231205','20231206'],
                    data: List
                },
                tableData: [
                    {
                        name: 'oppo',
                        todayBuy: 500,
                        monthBuy: 3500,
                        totalBuy: 22000
                    },
                    {
                        name: 'vivo',
                        todayBuy: 300,
                        monthBuy: 2200,
                        totalBuy: 24000
                    },
                    {
                        name: '蘋果',
                        todayBuy: 800,
                        monthBuy: 4500,
                        totalBuy: 65000
                    },
                    {
                        name: '魅族',
                        todayBuy: 300,
                        monthBuy: 1500,
                        totalBuy: 45000
                    },
                    {
                        name: '三星',
                        todayBuy: 300,
                        monthBuy: 2200,
                        totalBuy: 24000
                    },
                    {
                        name: '小米',
                        todayBuy: 800,
                        monthBuy: 4500,
                        totalBuy: 65000
                    }
                ]
            }
        }
    }
}